
import { Component, Vue } from "vue-property-decorator";
import IconReport from "@/components/common/icon/IconReports.vue";

@Component({
  name: "reports-header",
  components: {
    IconReport,
  },
})
export default class ReportsHeader extends Vue {}
